import { IAppStateModel } from '@models/IAppStateModel';

export const $selectRefresh = (state: IAppStateModel) => state.refresh;

export const $selectRefreshFiles = (state: IAppStateModel) => state.refresh.files;
export const $selectRefreshTasks = (state: IAppStateModel) => state.refresh.tasks;
export const $selectRefreshTeams = (state: IAppStateModel) => state.refresh.teams;
export const $selectRefreshMembers = (state: IAppStateModel) => state.refresh.members;
